import { Link } from 'react-router-dom';

const ServiceApply = () => {
    const menuItems = [
        {
            id: 1,
            title: '간병인 신청',
            path: '/service/apply/care'
        },
        {
            id: 2,
            title: '병원동행 신청',
            path: '/service/apply/escort'
        },
        {
            id: 3,
            title: '가사돌봄 신청',
            path: '/service/apply/housekeeping'
        },
        {
            id: 4,
            title: '내 주변',
            path: '/nearby/shop'
        }
    ];

    return (
        <main className="container">
            <section>
                <div className="inner">
                    <div className="login-logo">
                        <p className="txt">클릭 한 번으로 시작하는 프리미엄 케어</p>
                    </div>

                    <ul className="quick-menu-list">
                        {menuItems.map((item) => (
                            <li key={item.id}>
                                <Link to={item.path}>
                                    <span className="ico"></span>
                                    <h4>{item.title}</h4>
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <p className="guide_txt middle text-center mt30">
                        가족같은 마음으로, 전문가의 손길로<br/>
                        소중한 가족을 위한 서비스를 함께 하겠습니다.
                    </p>
                </div>
            </section>
        </main>
    );
};

export default ServiceApply;